import { Health, Setting, Grid5 } from "iconsax-react";

import IntlMessages from "../../layout/components/lang/IntlMessages";

const main = [
  {
    header: <IntlMessages id="sidebar-analysis" />,
  },
  {
    id: "analytics-supplier",
    title: <IntlMessages id="sidebar-analytics-supplier" />,
    icon: <i className="ph-fill ph-chart-line" />,
    navLink: "/analytics/supplier",
  },
  {
    id: "analytics-supplier-participation",
    title: <IntlMessages id="sidebar-supplier-participation" />,
    icon: <i className="ph-fill ph-chart-line" />,
    navLink: "/analytics/supplier-participation",
  },
  {
    id: "analytics-supplier-concentration-products",
    title: <IntlMessages id="sidebar-supplier-concentration-products" />,
    icon: <i className="ph-fill ph-chart-line" />,
    navLink: "/analytics/concentration-products",
  },
  {
    id: "analytics-supplier-purchase-frequency",
    title: <IntlMessages id="sidebar-supplier-purchase-frequency" />,
    icon: <i className="ph-fill ph-chart-line" />,
    navLink: "/analytics/purchase-frequency",
  },
];

export default main;
